import Marquee from "react-fast-marquee";

const ITEMS = [
  "DHA Licensing",
  "DOH Abu Dhabi",
  "MOHAP Licensing",
  "Healthcare Recruitment",
  "Clinic Consulting",
  "Interim Management",
];

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="border-y border-brand-gold/25 bg-brand-bone py-8 overflow-hidden">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center gap-24 pr-24">
            <span className="font-serif text-2xl sm:text-3xl text-brand-ink/80 italic">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-brand-gold" aria-hidden="true" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
